export const APP_METADATA = {
  default: {
    title: 'Clustr - All Your Content saved in one place',
    description: 'Build your own personal library for digital inspiration, curate your own private web of ideas',
    image: '/lovable-uploads/90dfc7a3-cf68-4c62-9c92-2899ac38ef86.png' // Using the provided Clustr logo
  },
  home: {
    title: 'Clustr Home - Your personal library for digital inspiration',
    description: 'Save, organize, and rediscover content from across the internet with your personal library for digital inspiration.',
    image: '/lovable-uploads/90dfc7a3-cf68-4c62-9c92-2899ac38ef86.png' // Using the provided Clustr logo
  },
  releases: {
    title: 'Clustr Release Notes - an experimental phase for validation',
    description: 'Clustr is currently in an experimental phase where we\'re validating the core concept and features.',
    image: '/lovable-uploads/74c71e1c-f446-4558-a10a-e69c985160f7.png' // existing hero image
  },
  intro: {
    title: 'Clustr Introduction - Capture, Organize, and Cultivate your digital inspiration',
    description: 'Learn how to use Clustr to save, organize, and revisit your digital inspiration. A visual content curation platform designed for creative professionals.',
    image: '/lovable-uploads/66e3ae0d-ecbd-42a6-be9a-1dbb3e7a08f4.png' // existing hero image
  },
  workflow: {
    title: 'Clustr Workflow - Capture, Organize, Connect, Build & Use your digital library',
    description: 'Learn how to integrate Clustr into your research and creative workflow for maximum productivity.',
    image: '/lovable-uploads/462e5a36-736f-407e-b6bd-7635a0be94a2.png' // workflow image
  },
  inbox: {
    title: 'Clustr In Box - Your unorganized content',
    description: 'Content not yet organized into collections. Process your inbox regularly to keep your digital library organized.',
    image: '/lovable-uploads/90dfc7a3-cf68-4c62-9c92-2899ac38ef86.png' // Using the Clustr logo
  },
  roadmap: {
    title: 'Clustr Roadmap - Many ideas, we need your feedback what to build',
    description: 'Outline of potential future development. Help prioritize that future.',
    image: '/lovable-uploads/db274e28-447c-433e-b3cb-6ec6fca4b3f6.png' // Updating to use the roadmap image
  },
  privacy: {
    title: 'Clustr Privacy - How the Clustr Web Clipper uses information about you',
    description: 'This Privacy Policy describes how the Clustr Web Clipper ("Extension") collects, uses, and shares information about you when you use our browser extension.',
    image: '/lovable-uploads/db360999-ccc1-43f4-a619-8f54bcf2c7c0.png' // logo_privacy.jpg
  },
  auth: {
    title: 'Clustr Authentication',
    description: 'Sign up & Sign in to Clustr',
    image: '/lovable-uploads/90dfc7a3-cf68-4c62-9c92-2899ac38ef86.png' // Using the provided Clustr logo
  },
  notFound: {
    title: 'Clustr Not Found Page',
    description: 'Redirect to home page',
    image: '/lovable-uploads/90dfc7a3-cf68-4c62-9c92-2899ac38ef86.png' // Using the provided Clustr logo
  }
};
